import { render, staticRenderFns } from "./UsersCreate.vue?vue&type=template&id=5ca603f0"
import script from "./UsersCreate.vue?vue&type=script&lang=js"
export * from "./UsersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports